// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1-oFY","fileBtn":"File_fileBtn__rVCXE","closeBtn":"File_closeBtn__255Ih","fileSelected":"File_fileSelected__2qA54","disabled":"File_disabled__rDeaX"};